import React, { useEffect, useState, useRef } from 'react';
import { sendRequest } from '../requests/useRequest';
import { validarSesion } from '../tokens/useToken';
import { useHistory } from 'react-router-dom';
import { ConfigServer } from '../../data/config';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';
import * as XLSX from 'xlsx';
import { useModal } from "react-morphing-modal";
import 'moment/locale/es';
import moment from 'moment';
import "react-datetime/css/react-datetime.css";
import { Button } from 'reactstrap';
import { createComments, modifyStatus, getWhatsApp, DetailInvoices, emailSendInvoice } from '../../services/dashboard/dashboard'
import { getAllTypeService } from '../../services/typeService/typeService'
import { labcen, pyrsa } from '../../constant/globalConstantsTypeClients'
import { Tag } from 'primereact/tag';





export const useDashboardCard = () => {


    console.log("🚀 ~ pyrsa:", pyrsa)


    //*VARIABLES LOCALES
    let id_branch = localStorage.getItem('branchId');
    let enable_tracking_toma = localStorage.getItem('enable_tracking_toma');
    let credit_payment = localStorage.getItem('credit_payment');
    let _url_helen = localStorage.getItem('url_helen');
    let maquila = localStorage.getItem('maquila');
    let _interfaced_hospital = localStorage.getItem('interfaced');
    let arrayStatus = JSON.parse(localStorage.getItem('unprintable_preview_status'));
    let branchName = localStorage.getItem('branchName');


    // ? ACTIVE MICROSANITARY
    let _active_micro = localStorage.getItem('active_microsanitary');
    let _title_dashboard = localStorage.getItem('title_dashboard');
    let enable_whatsapp = localStorage.getItem('enable_whatsapp');

    //*CONFIGURATION FINANCE
    let _valid_Finance = localStorage.getItem('finance');
    let _finance2 = localStorage.getItem('finance_view');






    const history = useHistory();


    const [orderTotal, setOrderTotal] = useState(0);
    const [examsAndProfile, setExamsAndProfile] = useState(0);
    const [countTotal, setCountTotal] = useState(0)
    const [nimData, setNimData] = useState([]);
    const [createSweet, sweetConfirmation, sweetDelete, sweetError, createSweett, sweetConfirmationUpdate, sweetConfirmRepeatExam] = useSweetAlert();
    const [patientTotal, setPatientTotal] = useState(0);
    const [patientCompany, setPatientCompany] = useState(0);
    const [loading, setLoading] = useState(false)
    const [orderCancell, setOrderCancell] = useState(0);
    const [typeModalPrintI, setTypeModalPrintI] = useState("viewPrintI");
    const [modalPrintI, setModalPrintI] = useState(false);
    const [dataExams, setdataExams] = useState([]);
    const [id_workorder_print, setid_workorder_print] = useState(0);
    const [typeModalInvoice, setTypeModalInvoice] = useState("viewInvoice");
    const [modalInvoice, setModalInvoice] = useState(false);
    const [InvoicePDF, setInvoicePDF] = useState("");
    const [nimDataExcel, setNimDataExcel] = useState([]);
    const [respuestaAPI, setRespuestaAPI] = useState({});
    const [dataCompany, setDataCompany] = useState([]);
    const [dataSend, setDataSend] = useState([]);
    const [sendTo, setSendTo] = useState([]);
    const [id_workorder_send, setid_workorder_send] = useState(0);
    const [commentPatient, setCommentPatient] = useState('');
    const [validinvoice, setvalidInvoice] = useState(false);
    const [filterSections, setFilterSections] = useState('TODOS');
    //*CHECK SPECIMEN
    const [checkSpecimens, setCheckSpecimens] = useState([]);
    const [specimensUncheck, setSpecimensUncheck] = useState([]);
    const [loadingSpecimen, setLoadingSpecimen] = useState(false);
    const [idW, setIdW] = useState(0)
    const [modalCheckSpecimen, setModalCheckSpecimen] = useState(false);
    const [chek, setChek] = useState([]);
    const [modalCheckDelivery, setModalCheckDelivery] = useState(false);
    const [idWorkOrder, setIdWorkOrder] = useState(0)

    //*MODAL CHECK SPECIMEN
    const [itemsTree, setItemsTree] = useState([]);
    const treeviewRef = useRef(null);
    const [dataPending, setDataPending] = useState([]);

    //*FILTER DASHBOARD
    const [viewFormFilters, setViewFormFilters] = useState(false);

    //*PREVIEW RESULTS
    const [typeModall, setTypeModall] = useState("ViewO");
    const [modalOrdenMedical, setModalOrdenMedical] = useState(false);
    const [workMedicalOrderPDF, setworkMedicalOrderPDF] = useState("");
    const [workMedicalOrderPDFDownload, setworkMedicalOrderPDFDownload] = useState('');
    const [loadingPdf, setLoadingPdf] = useState(false);

    //*CONFIGURATION WHATSAPP
    const [modalPreviewSend, setModalPreviewSend] = useState(false);
    const [validNumber, setValidNumber] = useState("");
    const [id_patient, setId_patient] = useState(0);

    //*TYPE SERVICE
    const [listTypeService, setListTypeService] = useState([]);

    //*VIEW EXAM
    const [enableViewTest, setEnableViewTest] = useState(false);
    const [typeNumber, setTypeNumber] = useState(0);
    const [justMe, setJustMe] = useState(false);

    const [loadingTrazability, setLoadingTrazability] = useState(false)
    const [totalClinical, setTotalClinical] = useState(0);
    // console.log("🦊 totalClinical", totalClinical);

    const [totalMicro, setTotalMicro] = useState(0);
    // console.log("🌈 totalMicro", totalMicro);

    const [sending, setSending] = useState(false);

    //*SEND RESULT
    const [openProfiles, setOpenProfiles] = useState({});
    const [markAllActive, setMarkAllActive] = useState(false);
    const [step, setStep] = useState(1);
    const [auditPanel, setAuditPanel] = useState(null);

    

    //*FORM VALUES
    const [formValues, handleInputChange, reset, handleUpdateValues, handleSelectValues, handlePickerValues] = useForm({
        nim: "",
        mDateRange1: "",
        mDateRange2: "",
        mSelectStatus: 0,
        ids_users: 0,
        id_company: 0,
        is_pending: 0,
        letter: false,
        id_type_service: 0
    });

    const { nim, mDateRange1, mDateRange2, mSelectStatus, ids_users, id_company, is_pending, letter, id_type_service } = formValues;

    //#region SPECIMEN
    //*ACTIONS MODAL

    const toggleMedical = () => {
        setModalOrdenMedical(!modalOrdenMedical);
    }

    const handleMedical = (id_workOrder) => {
        setTypeModall("ViewO")
        toggleMedical();
        previewWorkOrder(id_workOrder);
    }

    const toggleModalSend = () => {
        setModalPreviewSend(!modalPreviewSend);
    }

    const handleSendWhatss = (_id_workOrder, _number) => {
        toggleModalSend()
        setValidNumber(_number)
        setId_patient(_id_workOrder)
    }

    const handleInvoice = async (_id_workOrder, _UUID) => {
        setTypeModalInvoice("viewInvoice");
        toggleInvoice();
        previewInvoice(_id_workOrder, _UUID);
    }

    const toggleInvoice = () => {
        setModalInvoice(!modalInvoice);
    }

    const handleViewTest = () => {
        setEnableViewTest(true);
    }

    const handleCloseViewTest = () => {
        setEnableViewTest(!enableViewTest);
    }

    const toggleCheckSpecimen = () => {
        setModalCheckSpecimen(!modalCheckSpecimen);
    }

    const toggleCheckDelivery = () => {
        setModalCheckDelivery(!modalCheckDelivery)
    }

    const handleCheckDelivery = (id_workOrder) => {
        setIdWorkOrder(id_workOrder)
        toggleCheckDelivery();
    }

    const [sendConfig, setSendConfig] = useState({
        send_email: false,
        send_doctor: false,
        send_whatsapp: false,
        send_whatsapp_doctor: false,
        print_results: false
    });


    //#endregion SPECIMENT
    useEffect(() => {
        if (nimData.length === 0) {
            getAmount();
        }

    }, []);

    useEffect(() => {
        if (_interfaced_hospital === "True") {
            GetListTypeService()
        }
    }, [_interfaced_hospital])


    //*TYPE SERVICE
    const GetListTypeService = async (_id_type_service) => {
        const listService = await getAllTypeService(_id_type_service);

        if (listService?.length > 0) {
            const list = listService?.map(type => {
                return {
                    value: type?.id_work_order_type_service,
                    label: (
                        <>
                            <img alt="flask" className="img-fluid text-info mr-2" src={require("../../assets/images/typeService.svg")} style={{ width: "17px", height: "17px" }} />
                            <label className='pb-zero' style={{ fontSize: "11px", paddingBottom: "0px" }}>{type?.name}</label>
                        </>
                    ),
                    baseOption: `${type?.name}`
                }
            });
            setListTypeService(list);
        }
    }

    const handleChangeFilterService = async (e, nombre) => {
        handleUpdateValues({
            ...formValues,
            id_type_service: e
        })
    }

    //#region GET DASHBOARD
    const [PrimarycolorLineTab, setPrimarycolorLineTab] = useState('1');
    const [loadingMicro, setLoadingMicro] = useState(false)

    //*DASHBOARD
    const getdashboard = (e, search = true, valid = 0, _is_micro = null) => {

        console.log("Buscas");



        e.preventDefault();

        if (search) {
            let query = "";


            // ! CONFIGURATION MICROSANITARY
            if (_active_micro === "True" && _is_micro) {

                if (_is_micro) {
                    let mfrom = (mDateRange1) ? moment(mDateRange1).format("YYYY-MM-DD") : "";
                    let mto = (mDateRange2) ? moment(mDateRange2).format("YYYY-MM-DD") : "";

                    if (nim !== "") {
                        query += `&nim=${nim}`;
                    }

                    if (mfrom !== "") {
                        query += `&date_from=${mfrom}`;
                    }

                    if (mto !== "") {
                        query += `&date_to=${mto}&`;
                    }

                    if (mSelectStatus !== 0) {
                        query += `&status_work_order=${mSelectStatus.value}`;
                    }

                    if (ids_users !== 0) {
                        query += `&id_user=${ids_users.value}`;
                    }

                    if (id_company != 0) {
                        query += `&id_company=${id_company.value}`;
                    }

                    if (valid !== 0) {
                        query += `&is_pending=${1}`;
                    }

                    if (_interfaced_hospital === "True") {
                        if (id_type_service !== 0) {
                            query += `&id_type_service=${id_type_service.value}`;
                        }
                    }

                    if (_is_micro) {
                        setLoadingMicro(true)
                        setPrimarycolorLineTab("2")
                        query += `&is_micro=1`;
                        console.log("entra aqui");
                    }

                }
            }
            else {

                console.log("wilson");


                setLoading(true);


                let mfrom = (mDateRange1) ? moment(mDateRange1).format("YYYY-MM-DD") : "";
                // console.log("🚀 ~ getdashboard ~ mfrom:", mfrom)
                let mto = (mDateRange2) ? moment(mDateRange2).format("YYYY-MM-DD") : "";
                // console.log("🚀 ~ getdashboard ~ mto:", mto)

                if (nim !== "") {
                    query += `&nim=${nim}`;
                }

                if (mfrom !== "") {
                    query += `&date_from=${mfrom}`;
                }

                if (mto !== "") {
                    query += `&date_to=${mto}`;
                }

                if (mSelectStatus != 0) {
                    query += `&status_work_order=${mSelectStatus.value}`;
                }

                if (ids_users !== 0) {
                    query += `&id_user=${ids_users.value}`;
                }

                if (id_company !== 0) {
                    query += `&id_company=${id_company.value}`;
                }

                if (valid !== 0) {
                    query += `&is_pending=${1}`;
                }

                if (_interfaced_hospital === "True") {
                    if (id_type_service && id_type_service.value !== 0) {
                        query += `&id_type_service=${id_type_service.value}`;
                    }
                }

            }

            getAmount(true, query)
        }
    }

    const [totalInvoices, setTotalInvoices] = useState(0)


    const getAmount = async (search = false, filter = null, _is_micro = false, _justMe = justMe) => {


        setLoading(true);


        let requestOptions = {
            method: 'GET'
        };

        var respuesta = {};
        let respuestaEmail = {};
        const jsonData = localStorage.getItem('dashboard_currentpage');
        let persistence = null;
        if (jsonData) {
            persistence = JSON.parse(jsonData);
            console.log(persistence);
            console.log(filter);



            if (persistence.search == true && filter == null) {
                console.log("entrassss o que haces");

                search = true
                setViewFormFilters(true);
                handleUpdateValues({
                    nim: persistence.nim,
                    mDateRange1: persistence.mDateRange1,
                    mDateRange2: persistence.mDateRange2,
                    mSelectStatus: persistence.mSelectStatus,
                    ids_users: persistence.ids_users,
                    id_company: persistence.id_company
                });

                filter = "";
                if (persistence.nim !== "") {
                    filter += `&nim=${persistence.nim}`;
                }

                if (persistence.mDateRange1 !== "") {
                    filter += `&date_from=${persistence.mDateRange1}`;
                }

                if (persistence.mDateRange2 !== "") {
                    filter += `&date_to=${persistence.mDateRange2}`;
                }

                if (persistence.mSelectStatus !== 0) {
                    filter += `&status_work_order=${persistence.mSelectStatus}`;
                    console.log("🚀 ~ getAmount ~ filter:", filter)

                }

                if (persistence.ids_users !== 0) {
                    filter += `&id_user=${persistence.ids_users}`;
                }

                if (persistence.id_company != 0) {
                    filter += `&id_company=${persistence.id_company}`;
                }
            }
        }



        if (_justMe && !(filter || "").includes("just_me=true")) {
            console.log("🚀 ~ getAmount55 ~ _justMe:", _justMe);
            filter = filter ? `${filter}&just_me=true` : `just_me=true`;
        }
        console.log("🚀 ~ getAmount77777 ~ _justMe:", _justMe)

        if (search === false) {
            respuesta = await sendRequest(requestOptions, `WorkOrder/DetailDashboard${id_branch}`);

            respuestaEmail = respuesta.data.workOrderDetailPatient.filter((order) => order.send_doctor === true)
            setPrimarycolorLineTab("1")
        }

        else {
            console.log("entras con filtros por persistencia");

            setDatanim([]);
            respuesta = await sendRequest(requestOptions, `WorkOrder/DetailDashboard${id_branch}?` + filter);




        }

        let tmpSend = [];
        let tmpDetail = [];
        let tmpComment = [];
        let tmpCompanies = [];
        let tmpDetailExcel = [];
        let tmpDetailExcel2 = [];

        if (respuesta.code === 200) {
            setLoading(false);
            setLoadingMicro(false)



            let startItems = 0;
            let endItems = numberItems;
            let aux = numberItems * currentPage;

            endItems = aux;
            startItems = endItems - numberItems;

            let idW = 0

            if (respuesta.data.workOrderDetailPatient.length >= 1) {

                let filteredData = respuesta.data.workOrderDetailPatient;

                if (_valid_Finance === "True" && _finance2 === "False") {
                    filteredData = filteredData.filter(el => el.complete_information !== "True");
                }

                filteredData.forEach((element, index) => {

                    setCommentPatient(element.comment_patient);

                    let posicion = index + 1;
                    let visibleTable = false;

                    if (posicion > startItems && posicion <= endItems) {
                        visibleTable = true;
                    }

                    let validar_faltantes = false;
                    let validador = [];
                    idW = element.id_work_order

                    if (element.listProfileWorkOrders.length > 0) {
                        if (element.listProfileWorkOrders[0].listExam.length > 0) {
                            element.listProfileWorkOrders[0].listExam.forEach(({ check_specimen, id_specimen_origin }) => {
                                if (!check_specimen) {
                                    validar_faltantes = true;
                                }
                                if (validador.find(x => x.id === id_specimen_origin) === undefined) {
                                    validador.push({
                                        id: id_specimen_origin,
                                    })
                                }
                            });
                        }
                    }

                    if (element.listExam.length > 0) {
                        element.listExam.map(({ check_specimen, id_specimen_origin, }) => {
                            if (!check_specimen) {
                                validar_faltantes = true;
                            }
                            if (validador.find(x => x.id === id_specimen_origin) === undefined) {
                                validador.push({
                                    id: id_specimen_origin,
                                })
                            }
                        });
                    }

                    let commentsForOrder = null;

                    if (element.comment_patient && Array.isArray(element.comment_patient)) {
                        commentsForOrder = element.comment_patient.find(comment => comment.id_work_order === idW);
                    } else if (element.comment_patient && !Array.isArray(element.comment_patient)) {
                        commentsForOrder = { comment_patient: element.comment_patient };
                    }

                    tmpComment.push({
                        id_work_order: element.id_work_order,
                        id_patient: element.id_patient,
                        id_estatus_order: element.id_estatus_order,
                        comment_patient: commentsForOrder ? commentsForOrder.comment_patient : null,
                    })

                    tmpDetail.push({
                        id_work_order: element.id_work_order,
                        id_patient: element.id_patient,
                        id_estatus_order: element.id_estatus_order,
                        is_micro: element.is_micro,
                        nim: _interfaced_hospital === "True" ?
                            <div>
                                <label className='pb-zero' style={element.paid ? {} : { color: "#dc3545" }} >{element.nim}</label> <br />
                                <label className='pb-zero' style={{ fontSize: "11px", color: "#46AFE5", paddingBottom: "0px" }} >{element.type_service ?? "------"}</label>
                            </div>
                            :
                            element.name_company === null ?
                                <div className={element.is_micro ? "pt-0 mb-0" : ""}>
                                    <label className='pb-zero' style={element.paid ? {} : { color: "#dc3545" }} >{element.nim}</label>
                                    <div style={element.paid ? { fontSize: "11px", color: "", paddingBottom: "0px" } : { fontSize: "11px", color: "", paddingBottom: "0px", color: "#dc3545" }}>{"PARTICULAR"}</div>
                                </div>
                                :
                                <div className={element.is_micro ? "pt-0 mb-0 " : ""}>
                                    <label className='pb-zero' style={element?.paid ? {} : { color: "#dc3545" }}  >{element.nim}</label>
                                    <div className={element.is_micro ? 'pb-zero' : 'txt-secondary pb-zero'} style={element.is_micro ? { color: "#1d5b83", fontSize: "10px", paddingBottom: "0px" } : { fontSize: "10px", color: "txt-secondary", paddingBottom: "0px" }}>
                                        {element.name_company}
                                    </div>
                                </div>
                        ,
                        fechAndDate: element.validF === null ?
                            <div className={element.is_micro ? "" : ""}>
                                <Button style={{ pointerEvents: "none" }} color={element.is_micro ? 'info' : element.paid ? 'info' : "danger"} outline className={`btn btn-pill btn-xs`}>
                                    {element.fechAndDate}
                                </Button>
                                <label
                                    className={element.is_micro ? '' : element.paid ? 'txt-primary pb-zero' : "pb-zero txt-danger"}
                                    style={element.is_micro ? { fontSize: "10px", color: "#1d5b83", display: "block" } : { fontSize: "10px", display: "block" }}
                                >
                                    {element.dateFech}
                                </label>
                            </div>
                            :
                            <div className={element.is_micro ? "" : ""}>
                                <Button style={{ pointerEvents: "none" }} color='danger' outline className={`btn btn-pill btn-xs`}>
                                    {element.fechAndDate}
                                </Button>
                                <label
                                    className={element.paid ? 'txt-danger pb-zero' : 'txt-secondary pb-zero'}
                                    style={{ fontSize: "10px", display: "block" }}
                                >
                                    {element.dateFech}
                                </label>
                            </div>,

                        name_patient: element.name_patient === "  " ?
                            <div>
                                <label className='f-w-600 mb-0' style={{ color: "#1d5b83", display: "block" }}>
                                    {element?.name_company ?? "MICROSANITARIA"}
                                </label>
                                <label className={element.name_company === null ? "d-none mb-0" : "mb-0"} style={element.paid ? { display: "block" } : { display: "block", color: "#dc3545" }}>
                                    {element.name_agreement}
                                </label>
                            </div>
                            :
                            <>
                                {
                                    _url_helen === pyrsa ?
                                        <>
                                            <label className='mb-0' style={element.paid ? {} : { color: "#dc3545", display: "block" }}>{element?.name_patient}</label>
                                            {
                                                element?.name_company !== null && (
                                                    <div className={element?.name_company === null ? "d-none mb-0" : "f-w-600 pt-0 pb-0 mb-0"} style={element.paid ? { color: "#0d3b59", display: "block" } : { color: "#dc3545", display: "block" }}>
                                                        {element?.name_agreement ?? "N/A"}
                                                    </div>
                                                )
                                            }
                                        </>
                                        :
                                        <label className={element.paid ? "mb-0" : "txt-danger  pb-zero mb-0"} >{element?.name_patient}  </label>

                                }
                            </>
                        ,
                        name_branch: element.name_branch,
                        income_type: element.income_type,
                        is_parcial: element.is_parcial,
                        listExam: element.listExam,
                        listProfileWorkOrders: element.listProfileWorkOrders,
                        cont_check_specimen: validador.length,
                        validar_faltantes: validar_faltantes,
                        paid: element.paid,
                        indices: false,
                        valid_invoice: element.valid_invoice,
                        UUID: element.uuid,
                        is_send_email: element.is_send_email,
                        send_email: element.send_patient1,
                        send_doctor: element.send_doctor1,
                        send_whatsapp: element.send_whatsapp,
                        send_whatsapp_doctor: element.send_whatsapp_doctor,
                        id_company: element.id_company,
                        nim2: element.nim,
                        deliver: element.deliver,
                        valid_user_deliveri:
                            <div>
                                <label>Entregado por: {element.username_deliver}</label> <br />
                                <label>{element.fechAndHour_deliver}</label>
                                {element.comment_patient && (
                                    <label>Comentario: {element.comment_patient}</label>)}
                            </div>,
                        valid_sendAndDelivery:
                            <div>
                                <label>Entregado por: {element.username_deliver}</label> <br />
                                <label>{element.fechAndHour_deliver}</label>   <br />  <br />
                                <label>Enviado a correo por: {element.username_send}</label> <br />
                                <label>{element.fechAndHour_send}</label>   <br />
                                {element.comment_patient && (
                                    <label>Comentario: {element.comment_patient}</label>)}
                            </div>,
                        valid_sendAndDelivery2:
                            <div>
                                <label>Enviado a correo por: {element.username_send2}</label> <br />
                                <label>{element.fechAndHour_send2}</label>   <br />  <br />
                                {element.comment_patient && (
                                    <label>Comentario: {element.comment_patient}</label>)}
                            </div>,
                        send: element.send,
                        send2: element.send2,
                        is_invoiced: element.is_invoiced,
                        invoice_is_general_public: element.invoice_is_general_public,
                        show_print: element.show_print,
                        complete_information: element.complete_information,
                        phone_patient: element.phone_patient,
                        name_company: element.name_company,
                        visibleTable: visibleTable,

                    })
                });

                let consecutivo = 1;
                let statusExcel = "";

                respuesta.data.workOrderDetailPatient.forEach((item, index) => {

                    (item.id_estatus_order === 1) ? statusExcel = "ABIERTA" :
                        (item.id_estatus_order === 2) ? statusExcel = "EN PROGRESO" :
                            (item.id_estatus_order === 4) ? statusExcel = "VALIDADO" :
                                (item.id_estatus_order === 5) ? statusExcel = "PARCIAL" :
                                    (item.id_estatus_order === 6) ? statusExcel = "LIBERADO" :
                                        (item.id_estatus_order === 7) ? statusExcel = "ENVIADO" :
                                            (item.id_estatus_order === 8) ? statusExcel = "ENTREGADO" :
                                                (item.id_estatus_order === 9) ? statusExcel = "ENTREGADO-ENVIADO" :
                                                    (item.id_estatus_order === 10) ? statusExcel = "AUTORIZADO" :
                                                        (item.id_estatus_order === 13) ? statusExcel = "IMPRESO" :
                                                            (item.id_estatus_order === 17) ? statusExcel = "VALIDADO" :
                                                                (item.id_estatus_order === 20) ? statusExcel = "CANCELADO" :
                                                                    (item.id_estatus_order >= 21) ? statusExcel = item.id_estatus_order : statusExcel = item.id_estatus_order

                    tmpDetailExcel2.push({
                        Consecutivo: consecutivo++,
                        Nombre: item.name_patient,
                        Empresa: item.name_company == null ? "PARTICULAR" : item.name_company,
                        NIM: item.nim,
                        Estatus: statusExcel,
                        Pago: item.paid === true ? "PAGADO" : "ADEUDO"
                    })

                    tmpSend.push({
                        nim: item.nim,
                        send_patient: item.send_patient1,
                        send_doctor: item.send_doctor1,
                    })
                });

                const companyNamesSet = new Set();

                respuesta.data.workOrderDetailPatient.forEach((item, index) => {
                    if (item.id_company !== null && item.id_company !== 0) {
                        const companyName = item.name_company;

                        if (!companyNamesSet.has(companyName)) {
                            companyNamesSet.add(companyName);

                            tmpCompanies.push({
                                value: item.id_company,
                                label: companyName,
                            });
                        }
                    }
                });
            }

            if (jsonData) {
                if (persistence.search == true) {
                    goToPage(persistence.currentPage)
                }
                else {
                    const today = new Date().toISOString().split('T')[0];
                    if (persistence.today === today) {
                        goToPage(persistence.currentPage)
                    }
                    else {
                        localStorage.removeItem('dashboard_currentpage');
                    }
                }
            }

            setRespuestaAPI(respuestaEmail);
            setOrderTotal(respuesta.data.total_Work_Orders);
            setExamsAndProfile(respuesta.data.total_ExamAndPerfil);
            setNimData([...tmpDetail]);
            setNimDataExcel([...tmpDetailExcel2]);
            setCountTotal(respuesta.data.total_MountEP);
            setPatientTotal(respuesta.data.total_Patient);
            setPatientCompany(respuesta.data.total_PatienCompany);
            setOrderCancell(respuesta.data.total_cancell);
            setDatanim([...tmpDetail]);
            setDataCompany([...tmpCompanies]);
            setDataSend([...tmpSend]);
            setCommentPatient([...tmpComment])
            setvalidInvoice(respuesta.data.service_invoice)
            setTotalInvoices(respuesta.data.total_invoice)
            setTotalClinical(respuesta.data.total_clinical)
            setTotalMicro(respuesta.data.total_micro)

        }
    }

    //*CONFIGURATION FILTER DASHBOARD
    const handleCleanFilter = () => {
        localStorage.removeItem('dashboard_currentpage');
        setJustMe(false);
        handleUpdateValues({
            nim: "",
            mDateRange1: "",
            mDateRange2: "",
            mSelectStatus: 0,
            ids_users: 0,
            id_company: 0,
            id_type_service: 0

        })
        getAmount(false)

    }


    //*CONFIGURATION FILTER DASHBOARD
    //     const handleCleanFilterMicro = () => {
    //         localStorage.removeItem('dashboard_currentpage');
    //         handleUpdateValues({
    //             nim: "",
    //             mDateRange1: "",
    //             mDateRange2: "",
    //             mSelectStatus: 0,
    //             ids_users: 0,
    //             id_company: 0,
    //             id_type_service: 0

    //         })
    //         setPrimarycolorLineTab("2")
    //         getAmount(true, null, true)


    //     }

    const handleCleanFilterMicro = () => {
        localStorage.removeItem('dashboard_currentpage');

        setNimData([]);
        setDatanim([]);
        setExpandedRows([]);

        handleUpdateValues({
            nim: "",
            mDateRange1: "",
            mDateRange2: "",
            mSelectStatus: 0,
            ids_users: 0,
            id_company: 0,
            id_type_service: 0
        });

        setPrimarycolorLineTab("2");
        getAmount(true, "&is_micro=1", true);
    }


    //*CONFIGURATION FILTER DASHBOARD
    // const handleView = () => {

    //     getAmount(false)
    //     setPrimarycolorLineTab("1")

    // }
    const handleView = () => {
        localStorage.removeItem('dashboard_currentpage');
        setPrimarycolorLineTab("1");

        setNimData([]);
        setDatanim([]);

        getAmount(false);
    }

    const handleViewFilters = () => {
        setViewFormFilters(!viewFormFilters);
    }
    //#endregion GET DASHBOARD

    //*BROWSE METHODS
    const navigateUpdate = (_workOrderId) => {
        let value = "" + _workOrderId + "";
        history.push(`../admisiones/${value}/editar`);
    }

    const navigateConfigEtiqueta = (_id_workOrder) => {

        history.push("../busqueda/" + _id_workOrder + "/detalle-orden");
    }

    const [modalAlert, setModalAlert] = useState(false);


    const toggleAlert = () => {
        setModalAlert(!modalAlert);
        // setMessage(false)
    }
    const [showInvoiceAlert, setShowInvoiceAlert] = useState(false);


    const navigateInvoice = (_workOrderId, _idPatient, _id_company, _isInvoiced) => {

        if (_isInvoiced === true) {
            setShowInvoiceAlert(true);
            setModalAlert(true)
            return;
        }

        let _validCompany = _id_company == null ? 0 : _id_company;
        let _validPatient = _idPatient == null ? 0 : _idPatient;

        history.push(`../invoice/${_workOrderId}/${_validPatient}/${_validCompany}/service`);
    }

    //#region method absolutes

    const printTicket = async (id_workOrder) => {

        let order = nimData.find(w => w.id_work_order === parseInt(id_workOrder));

        let id = order.id_work_order

        if (id_workOrder > 0) {

            let token = localStorage.getItem("token");

            await fetch(ConfigServer.serverUrl + "/api/PrintTicket/PrintTicket/" + id, {
                method: 'POST',
                headers: new Headers({
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/json"
                })
            })
                .then(response => {
                    if (response.status !== 200) {
                        createSweet("warning", "warning", "No se descargo el Ticket");
                        return;
                    }
                    return response.blob();
                })
                .then(blob => {
                    var url = window.URL.createObjectURL(blob);

                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "ticket.pdf")
                    document.body.appendChild(link);
                    link.style.display = 'none';
                    link.click();
                })
        }
    }

    const printSticker = async (id_workOrder) => {

        let order = nimData.find(w => w.id_work_order === parseInt(id_workOrder));

        let id = order.id_work_order;
        let is_micro_sanitary = order.is_micro;
        let url = "/api/PrintTicket/PrintStickers/";
        if (is_micro_sanitary == true) {
            url = "/api/PrintTicket/PrintStickersMicro/";
        }

        if (id_workOrder > 0) {

            let token = localStorage.getItem("token");

            await fetch(ConfigServer.serverUrl + url + id, {
                method: 'GET',
                headers: new Headers({
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/json"
                })
            })
                .then(response => {
                    if (response.status !== 200) {
                        createSweet("warning", "warning", "No se descargo la Etiqueta");
                        return;
                    }
                    return response.blob();
                })
                .then(blob => {
                    var url = window.URL.createObjectURL(blob);

                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "etiquetas.pdf")
                    document.body.appendChild(link);
                    link.style.display = 'none';
                    link.click();
                })
        }
    }

    const previewWorkOrder = async (id_workOrder) => {
        setLoadingPdf(true)
        let token = localStorage.getItem("token");

        let order = nimData.find(w => w.id_work_order === parseInt(id_workOrder));
        let id = order.nim2

        await fetch(ConfigServer.serverUrl + `/api/PrintResult/PreviewAlt?nim=${id}&type=NP&is_micro_sanitary=${false}&is_preview=true`, {
            method: 'GET',
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
            .then(response => {
                if (response.status !== 200) return;
                return response.json();
            })
            .then(async data => {
                await fetch(`${ConfigServer.serverUrl}/api/PrintResult/GetFile/${data.watermark}`, {
                    method: 'GET',
                    headers: new Headers({
                        "Authorization": "Bearer " + token,
                        "Content-Type": "application/json"
                    })
                })
                    .then(response => {
                        if (response.status !== 200) {
                            return;
                        }
                        return response.blob();
                    })
                    .then(blob => {
                        const url = window.URL.createObjectURL(blob);
                        setLoadingPdf(false);
                        setworkMedicalOrderPDF(url);
                        setworkMedicalOrderPDFDownload(`${ConfigServer.serverUrl}/api/PrintResult/DownloadFile/${id}/${data.raw}?jwt=${token}`);
                    });
            });
    }

    const printWorkOrder = async (id_workOrder) => {

        let order = nimData.find(w => w.id_work_order === parseInt(id_workOrder));

        let id = order.nim2

        let payload = {
            "nim": id,
            "password": "",
            "type": "NP"
        }
        let data = JSON.stringify(payload);
        let token = localStorage.getItem("token");

        await fetch(ConfigServer.serverUrl + "/api/PrintResult/DownloadSheetResults", {
            method: 'POST',
            body: data,
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
            .then(response => {
                if (response.status !== 200) {
                    createSweet("warning", "warning", "No se ha podido descargar el pdf");
                    return;
                }
                return response.blob();
            })
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "hoja_resultados_" + nim + ".pdf");
                document.body.appendChild(link);
                link.click();
                createSweet("success", "success", "Descarga completa");
            });
    }
    //#endregion method absolutes

    //#region actions dashboard
    //*COMMENT
    const saveComment = async (_id_workOrder, _comment) => {
        const viewComment = await createComments(_id_workOrder, _comment);

        if (viewComment !== null) {
            createSweet("", "success", "Éxito", "Éxito, comentario guardado");
        }
        else {
            createSweet("error", "error", "El NIM no cuenta con una toma de muestra");
        }
    }

    //*DELIVERI RESULT
    const changeEstatus = async (_id_workOrder, _comment) => {
        const changeEstatus = await modifyStatus(_id_workOrder, _comment);

        if (changeEstatus !== null) {
            const list = nimData?.map(_status => {
                if (_status.id_work_order === _id_workOrder) {
                    if (_status.id_estatus_order === 7) {
                        _status.id_estatus_order = 9;
                        _status.id_estatus_order = 6;
                    } else {
                        _status.id_estatus_order = 8;
                    }
                }
                return _status;
            });
            setNimData([...list]);
            createSweet("update", "success", "El estatus de la Ordén de Trabajo ha sido modificado.");

            if (_comment !== undefined && _comment !== null) {
                getAmount();
            }
            saveComment(_id_workOrder, _comment)
            toggleCheckDelivery();
        }
        else {
            createSweet("error", "error", "Ocurrio un problema al entregar");
        }
    }

    //*SEND WHATSAPP
    const sendResultsWhatsapp = async (id_work_order) => {
        createSweet("create", "warning", "Enviando...", "");
        const viewComment = await getWhatsApp(id_work_order);

        if (viewComment !== null) {
            createSweet("create", "success", "Exito!", "Los resultados se han enviado correctamente por este medio.");
            toggleModalSend();
            setValidNumber("");
            setId_patient(0);
        }
        else {
            createSweet("error", "error", "No se a podido realizar el envio correcto");
        }
    }

    //*PREVIEW INVOICES
    const previewInvoice = async (_id_workOrder, uuid) => {
        const viewInvoice = await DetailInvoices(_id_workOrder, uuid);

        if (viewInvoice !== null) {
            setLoadingPdf(false)
            setInvoicePDF(viewInvoice.cadena);
        }

    }

    //*EMAIL SEND INVOICES
    const sendResultForEmail = async (_id_workOrder, _UUID) => {
        createSweet("create", "warning", "Enviando correo...", "");

        const sendInvoices = await emailSendInvoice(_id_workOrder, _UUID);

        if (sendInvoices !== null) {
            const email = nimData?.map(_send => {
                if (_send.id_work_order === _id_workOrder) {
                    if (_send.is_send_email === false) {
                        _send.is_send_email = true;
                    }
                }
                return _send;
            });
            setNimData([...email]);
            createSweet("create", "success", "Exito!", "Los resultados se han enviado correctamente");
        }
        else {
            createSweet("error", "error", "Ocurrio un problema al entregar");
        }
    }
    //#endregion actions dashboard

    //#region Muestra
    const handleModalCheckSpecimen = async (id_workOrder) => {

        let work_order = nimData.find(x => x.id_work_order === id_workOrder);
        console.log("🚀 ~ handleModalCheckSpecimen ~ work_order:", work_order)
        let array_specimens = [];
        let array_nuevo = [];
        let arrayChek = [];

        if (work_order.listProfileWorkOrders.length > 0) {
            if (work_order.listProfileWorkOrders[0].listExam.length > 0) {
                work_order.listProfileWorkOrders[0].listExam.map(obj => {
                    if (!array_specimens.find(x => x.id_specimen_origin === obj.id_specimen_origin)) {
                        array_nuevo.push({
                            id: obj.id_specimen_origin,
                            check: obj.check_specimen,
                            name_specimen_origin: obj.name_specimen_origin
                        })
                        arrayChek.push({
                            status: obj.check_specimen
                        })
                    }
                    array_specimens.push(obj);
                })
            }
        }

        let _isToma = await handleRequest("GET", `Sample/DetailSample/${work_order.nim2}`, 'sample');
        console.log("🚀 ~ handleModalCheckSpecimen ~ _isToma:", _isToma)

        if (work_order.listExam.length > 0) {
            console.log("🚀 ~ handleModalCheckSpecimen ~ _isToma:", _isToma)
            work_order.listExam.map(obj => {
                if (!array_specimens.find(x => x.id_specimen_origin === obj.id_specimen_origin)) {
                    array_nuevo.push({
                        id: obj.id_specimen_origin,
                        check: obj.check_specimen,
                        name_specimen_origin: obj.name_specimen_origin
                    })
                    arrayChek.push({
                        status: obj.check_specimen
                    })
                }
                array_specimens.push(obj)
            });
        }
        setCheckSpecimens(array_nuevo);
        setSpecimensUncheck(array_specimens);
        setChek(arrayChek)
        setIdW(id_workOrder)

        let arrayNuevo = [];
        arrayNuevo.push({
            "profiles": work_order.listProfileWorkOrders,
            "exams": work_order.listExam,
            "is_toma": _isToma.length > 0 ? _isToma : ''
        })
        console.log("🚀 ~ handleModalCheckSpecimen ~ arrayNuevo:", arrayNuevo)
        let tree = createTree(arrayNuevo);
        setItemsTree(tree);
        toggleCheckSpecimen();
    }

    const createTree = (arrayNuevo) => {

        let tree = [];
        arrayNuevo.forEach(element => {
            //exam
            if (element.exams.length > 0) {

                element.exams.forEach(x => {
                    tree.push({
                        "children": [],
                        "id": x.id_work_order_exam,
                        "id_exam": x.id_exam,
                        "state": (x?.check_forwarded === false && (x?.is_toma === '' || x?.is_toma === undefined)) ? 2 : x?.refused_check_specimen === false ? 1 : 2,
                        "text": x.name,
                        "isLeaf": x?.check_specimen,
                        "refused_check_specimen": x.refused_check_specimen,
                        "check_forwarded": x.check_forwarded,
                        "is_send1": x.is_send1,
                        "is_send2": x.is_send2,
                        //  "is_send3": x.is_send3,
                        "is_toma": x.is_toma,
                        "valueDontSend": x.valueDontSend,
                        "pending": x.pending
                    })
                });
            }
            //profile
            if (element.profiles.length > 0) {
                element.profiles.forEach(_p => {
                    let examenes_aux = [];
                    let id = true;
                    let checy = 0;
                    let is_send1 = false;
                    let is_send2 = false;
                    let check_forwarded = false;
                    let id_work_order = 0

                    _p.listExam.forEach((_e) => {
                        examenes_aux.push({
                            "id": _e.id_work_order_exam,
                            "isLeaf": _e.check_specimen,
                            "state": (_e.check_forwarded === false && (_e?.is_toma === '' || _e?.is_toma === undefined)) ? 2 : _e.refused_check_specimen === false ? 1 : 2,
                            "text": _e.name,
                            "refused_check_specimen": (_e.check_forwarded === false && (_e?.is_toma === '' || _e?.is_toma === undefined)) ? true : _e.refused_check_specimen,
                            "is_send1": _e.is_send1,
                            "is_send2": _e.is_send2,
                            "check_forwarded": _e.check_forwarded,
                            "id_work_order": _e?.id_work_order,
                            "is_toma": _e?.is_toma,
                        });
                        id = _e.check_specimen;
                        checy = (_e.check_forwarded === false && (_e?.is_toma === '' || _e?.is_toma === undefined)) ? 2 : _e.refused_check_specimen === false ? 1 : 2;
                        is_send1 = _e.is_send1;
                        is_send2 = _e.is_send2;
                        check_forwarded = _e.check_forwarded;
                        id_work_order = _e?.id_work_order
                    });

                    tree.push({
                        "children": examenes_aux,
                        "state": checy,
                        "text": _p.name_profile,
                        "isLeaf": id,
                        "is_send1": is_send1,
                        "is_send2": is_send2,
                        "check_forwarded": check_forwarded,
                        "id_work_order": id_work_order,

                    });
                });
            }
        });
        return tree;
    }

    const changeTree = (e) => {
        changeStatus(e)
    }

    const changeStatus = async (e, id_work_order) => {

        const api = treeviewRef.current.api
        const items = api.getItems();

        let pending = [];

        //exams
        items.forEach(element => {
            if (element.id !== undefined) {

                {
                    pending.push({
                        "id_work_order": idW,
                        "id_work_order_exam": element.id,
                        "list_specimensToma": [
                            {
                                "check_forwarded": element.state === 1 ? true : false,
                                "name": element.text
                            }
                        ]
                    });
                }
            }
            //profiles
            else {
                element.children.forEach(ex => {
                    console.log("🚀 ~ changeStatus ~ ex:", ex)

                    if (ex.id !== undefined) {
                        pending.push({
                            "id_work_order": idW,
                            "id_work_order_exam": ex.id,
                            "list_specimensToma": [
                                {
                                    "check_forwarded": ex.state === 1 ? true : false,
                                    "name": ex.text

                                }
                            ]
                        });

                    }

                })
            }

        });

        setDataPending(pending)


    }

    //*PROCESS MAQUILA
    const processMaquila = async () => {
        let maquilaExams = await handleRequest("GET", `ExamBranchesMaquila/List/${id_branch}`)
        let _listExams = itemsTree;
        let _foundNotMaquila = [];


        _listExams.forEach((item, index) => {
            if (item.state === 1) {
                let _children = item.children;

                let foundMaquilaExam = maquilaExams.find(x => x.id_exam === item.id_exam);


                if (foundMaquilaExam === undefined) {
                    _foundNotMaquila.push({
                        "id_work_order": idW,
                        "id_work_order_exam": item.id
                    });
                }

                _children.forEach((child, IChild) => {
                    if (child.state === 1) {

                        let foundChild = maquilaExams.find(x => x.id_exam === child.id_exam);

                        if (foundChild === undefined) {
                            _foundNotMaquila.push({
                                "id_work_order": idW,
                                "id_work_order_exam": child.id
                            });
                        }
                    }
                })
            }
        })


        let processMaquila = await handleRequest("POST", "Sample/ProcessMaquila", "Sample", _foundNotMaquila)

    }

    const savePendingMuestra = async () => {

        let requestOptions = {
            method: 'POST',
            body: JSON.stringify(dataPending)
        };
        const respuesta = await sendRequest(requestOptions, "Sass/CheckSpecimenFlebotomia");

        if (maquila === true || maquila === "True") {
            processMaquila();
        }

        if (respuesta.code === 200) {

            let newWorkOrders = nimData;

            newWorkOrders = newWorkOrders.map(element => {
                let validar_faltantes = false;
                let validador = [];

                if (element.id_work_order === idW) {
                    if (element.listProfileWorkOrders.length > 0) {
                        if (element.listProfileWorkOrders[0].listExam.length > 0) {
                            element.listProfileWorkOrders[0].listExam.map(obj => {
                                dataPending.forEach(elem => {
                                    elem.list_specimensToma.forEach(elements => {
                                        if (elem.id_work_order_exam === obj.id_work_order_exam) {
                                            obj.check_forwarded = elements.check_forwarded
                                        }
                                        if (!elements.check_forwarded) {
                                            validar_faltantes = true;
                                        }
                                    });
                                });
                                return obj;
                            });
                        }
                    }

                    if (element.listExam.length > 0) {
                        element.listExam.map(obj => {
                            dataPending.forEach(ele => {


                                ele.list_specimensToma.forEach(e => {
                                    if (ele.id_work_order_exam === obj.id_work_order_exam) {
                                        obj.check_forwarded = e.check_forwarded;
                                    }

                                    if (!e.check_forwarded) {
                                        validar_faltantes = true;
                                    }
                                });

                            });
                            return obj;
                        })
                    }
                    element.cont_check_specimen = validador.length;
                    element.validar_faltantes = validar_faltantes;
                }
                return element;
            });

            setNimData(newWorkOrders);

            createSweet("success", "success", "Muestra Pendiente", "Muestra Actualizada");
        }
        toggleCheckSpecimen();
    }
    //#endregion Muestra

    //#region pagination

    const numberItems = 10;

    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(nimData.length, numberItems);

    useEffect(() => {
        if (nimData.length > 0) {
            const today = new Date().toISOString().split('T')[0];
            const data = {
                currentPage: currentPage,
                search: true,
                today: today,
                nim: nim,
                mDateRange1: mDateRange1,
                mDateRange2: mDateRange2,
                mSelectStatus: mSelectStatus,
                ids_users: ids_users,
                id_company: id_company
            };
            const jsonData = JSON.stringify(data);
            localStorage.setItem('dashboard_currentpage', jsonData);

            console.log(jsonData);
            console.log("log del efecto");





        }


        let listDashboard = [];
        nimData.forEach((data, key) => {


            listDashboard.push({
                ...data,
            });
        });

        setNimData(listDashboard);

    }, [totalPageCount, currentPage]);

    const [datanim, setDatanim] = useState([]);
    //#endregion pagination

    //#region Historic Sample

    // modalFullRef

    const [typePending, setTypePending] = useState("Pending");
    const [modalPending, setModalPending] = useState(false);
    const [loadingSample, setLoadingSample] = useState(false);
    const [dataSample, setDataSample] = useState([]);
    const [dataSendProcess2, setDataSendProcess2] = useState([]);
    const [dataSendProcess3, setDataSendProcess3] = useState([]);
    const [dataTrackingRecepetion, setDataTrackingRecepetion] = useState([]);
    const [dataSection, setDataSection] = useState([]);
    const [dataID, setDataID] = useState([]);

    const [key, setKey] = useState(0);
    const [namePatient, setNamePatient] = useState("");
    const [idGender, setIdGender] = useState(0);



    const [state, setState] = useState(prevState => ({
        ...prevState,
        text: "",
        number: 0
    }));


    const { close, modalProps, open } = useModal({
        onClose: () => setKey(key => key + 1),
        background: "#fff"
        //  background: rgba(0, 121, 199, 0.15)

    });



    const handleTrazabilidad = (_idW, _nim, _modalFullRef, _namePatient, _idGender) => {
        console.log("🚀 ~ handleTrazabilidad ~ _idGender:", _idGender)
        console.log("🚀 ~ handleTrazabilidad ~ _namePatient:", _namePatient)
        console.log("🚀 ~ handleTrazabilidad ~ _modalFullRef:", _modalFullRef)
        console.log("🚀 ~ handleTrazabilidad ~ _nim:", _nim)
        console.log("🚀 ~ handleTrazabilidad ~ _idW:", _idW)

        let work_order = nimData.find(x => x.id_work_order === _idW);
        let arrayNuevo = [];



        arrayNuevo.push({
            "profiles": work_order.listProfileWorkOrders,
            "exams": work_order.listExam
        })

        let tree = createTree(arrayNuevo);
        setItemsTree(tree);
        // handleGetSample(work_order.nim2);  //
        // handleGetSendProcess2(_idW);//
        // handleGetSendProcess3(_idW);//
        //handleGetTrackingReception(_idW);//
        setNamePatient(_namePatient);
        setIdGender(_idGender);
        open(_modalFullRef)
        handleGetTraceability(_idW)
    }

    const toggleHistoric = () => {
        setModalPending(!modalPending);
    }
    const [dataTraceability, setDataTraceability] = useState([])


    const handleGetTraceability = async (_id) => {
        setLoadingTrazability(true);

        const response = await handleRequest("GET", `Sass/GetTraceability/${_id}`, 'sample');

        if (response && Array.isArray(response)) {
            const estudios = [];

            response.forEach(item => {
                const profileGroups = {};

                if (Array.isArray(item.traceabilitExams)) {
                    item.traceabilitExams.forEach(exam => {
                        const arrayCurves = (exam?.arrayCurves ?? []).sort((a, b) => a.num_samplings - b.num_samplings);

                        estudios.push({
                            id_exam: exam?.id_exam ?? 0,
                            id_work_order_exam: exam?.id_work_order_exam ?? 0,
                            name: (
                                <label
                                    style={
                                        exam?.check_forwarded
                                            ? { color: "#245075" }
                                            : exam?.is_curve
                                                ? (
                                                    exam?.arrayCurves?.every(curve => !!curve?.user_flebo)
                                                        ? { color: "#51bb25" }
                                                        : { color: "#FF8F00" }
                                                )
                                                : (
                                                    exam?.traceabilitSampling.length === 0
                                                        ? { color: "#FF8F00" }
                                                        : { color: "#51bb25" }
                                                )
                                    }
                                >
                                    {exam?.name ?? "---"}
                                </label>
                            ),
                            refused_check_specimen: exam?.refused_check_specimen ?? "---",
                            check_forwarded: exam?.check_forwarded ?? "---",
                            is_send1: exam?.is_send1 ?? false,
                            is_send2: exam?.is_send2 ?? false,
                            is_toma: exam?.is_toma ?? false,
                            pending: exam?.pending ?? false,
                            traceabilitSampling: exam?.traceabilitSampling ?? [],
                            traceabilitSend: exam?.traceabilitSend ?? [],
                            type: 'exam',
                            is_curve: exam?.is_curve ?? false,
                            arrayCurves: arrayCurves ?? []
                        });
                    });
                }

                if (Array.isArray(item.traceabilitProfiles)) {
                    item.traceabilitProfiles.forEach(profile => {

                        if (!profileGroups[profile.name_profile]) {
                            profileGroups[profile.name_profile] = [];
                        }

                        let profileNameColor = '';

                        profile.listExam.forEach(_exams => {

                            const examColor = _exams?.check_forwarded ? { color: "#245075" } : _exams?.traceabilitSampling.length === 0 ? { color: '#FF8F00' } : { color: "#51bb25" };

                            if (_exams?.traceabilitSampling.length === 0) {
                                profileNameColor = '#FF8F00';
                            } else if (!_exams?.check_forwarded) {
                                profileNameColor = '#51bb25';
                            } else {
                                profileNameColor = '#245075';
                            }

                            profileGroups[profile.name_profile].push({
                                id_exam: _exams?.id_exam ?? 0,
                                id_work_order_exam: _exams.id_work_order_exam ?? 0,
                                name: <label style={examColor}>{_exams.name ?? "---"}</label>,
                                refused_check_specimen: _exams.refused_check_specimen ?? false,
                                check_forwarded: _exams.check_forwarded ?? false,
                                is_send1: _exams.is_send1 ?? false,
                                is_send2: _exams.is_send2 ?? false,
                                is_toma: _exams.is_toma ?? false,
                                pending: _exams.pending ?? false,
                                traceabilitSampling: _exams.traceabilitSampling ?? [],
                                traceabilitSend: _exams.traceabilitSend ?? [],
                                type: 'exam',
                                profile_name: profile?.name_profile ?? "---"
                            });
                        });

                        estudios.push({
                            type: 'profile',
                            profile_name: <label style={{ color: profileNameColor }}>{profile?.name_profile ?? "---"}</label>,
                            listExm: profileGroups[profile.name_profile]
                        });
                    });
                }
            });


            setDataTraceability(estudios);
        }

        setLoadingTrazability(false);
    };



    const handleGetSample = async (_nim) => {

        setLoadingSample(false);


        let _listTmp = await handleRequest("GET", `Sample/DetailSample/${_nim}`, 'sample');

        console.log("🚀 ~ handleGetSample ~ _listTmp:", _listTmp)

        if (_listTmp !== null) {
            setLoadingSample(true);
            setDataSample(_listTmp)
        }


    }

    const [refusedGlobal, setRefusedGlobal] = useState([]);

    const handleGetSendProcess2 = async (_idW) => {

        let _listTmp = await handleRequest("GET", `Sample/DetailSendSample1/${_idW}`, 'sample');
        if (_listTmp !== null) {
            setDataSendProcess2(_listTmp)
        }

        let _reasonRefused = await handleRequest("GET", `Sass/GetRefusedGlobal/${_idW}`);


        let _refusedGlobal = [];

        if (_refusedGlobal !== null) {
            _refusedGlobal.push({
                "reason": _reasonRefused.reason,
                "user": _reasonRefused.user,
                "origen": _reasonRefused.origen
            });
        }

        setRefusedGlobal(...[_refusedGlobal]);

    }

    const handleGetSendProcess3 = async (_idW) => {

        let _listTmp = await handleRequest("GET", `Sample/DetailSendSample2/${_idW}`, 'sample');
        if (_listTmp !== null) {
            setDataSendProcess3(_listTmp)
        }
    }

    const handleFilterSections = (filterTo) => {
        setFilterSections(filterTo);
    }

    const handleGetTrackingReception = async (_idW) => {

        let _listTmp = await handleRequest("GET", `Sample/DetailtrackingReception/${_idW}`, 'sample');
        if (_listTmp !== null) {
            let nuevoObjeto = [];
            let indexObject = [];

            if (_listTmp.length >= 0) {
                _listTmp.forEach(x => {
                    if (!nuevoObjeto.hasOwnProperty(x.nameSection)) {
                        nuevoObjeto[x.nameSection] = {
                            secciones: []
                        }
                        indexObject.push(x.nameSection);
                    }
                    nuevoObjeto[x.nameSection].secciones.push({
                        nombre: x.nameExam,
                        proces: x.initFech
                    })
                });
                setDataSection(nuevoObjeto);
                setDataID(indexObject);
            }
            else {
                setDataSection([]);
                setDataID([]);

            }
            setDataTrackingRecepetion(_listTmp)
        }
    }
    //#endregion Historic Sample

    //#region PRINT PDF RESULT
    const handleListPrint = async (id_work_order) => {

        let _listTmp = await handleRequest("GET", `WorkOrder/GetExambyWorkOrder/${id_work_order}`, 'invoice');

        if (_listTmp !== null) {
            let dataExamsTemp = [];
            _listTmp.forEach((data, index) => {
                if (data.listExam != "[]") {
                    data.listExam.forEach((data, index) => {
                        dataExamsTemp.push({
                            "id_work_order_exam": data.id_work_order_exam,
                            "id_work_order_profile": null,
                            "id_estatus": data.id_estatus,
                            "id_profile": null,
                            "id_exam": data.id_exam,
                            "name": data.name,
                            "listExam": [],
                            "check_box": false,
                            "sendBy": data.sendBy,
                            "show_print": data.show_print

                        });
                    });

                }
                if (data.listProfile != "[]") {
                    data.listProfile.forEach((data, index) => {
                        dataExamsTemp.push({
                            "id_work_order_exam": data.id_work_order_exam,
                            "id_work_order_profile": data.id_work_order_profile,
                            "id_estatus": data.id_status,
                            "id_profile": data.id_profile,
                            "id_exam": null,
                            "name": data.name_profile,
                            "listExam": data.listExam,
                            "check_box": false,
                            "gatos": 155,
                            "show_print": data.show_print

                        });
                    });
                }
                setid_workorder_print(id_work_order);
                setdataExams(dataExamsTemp);
                setTypeModalPrintI("viewPrintI")
                togglePrintI();
            });
        }
    }

    const handleCheckProfile = (e, id_profile, id_exam, id_work_order_profile, id_work_order_exam) => {
        let copyTest = [...dataExams];
        let valor = e.target.checked;
        let elementToUpdate = copyTest.find(x => id_profile != null && id_exam != null ?
            x.id_work_order_profile === id_work_order_profile && x.id_profile === id_profile :
            x.id_work_order_exam === id_work_order_exam && x.id_exam === id_exam);
        if (elementToUpdate) {
            if (id_profile != null && id_exam != null) {
                elementToUpdate.listExam.map(i => {
                    if (i.id_exam == id_exam) {
                        i.check_box = valor;
                    }
                    return i;
                });

            } else {
                elementToUpdate.check_box = valor;
            }
        }
        setdataExams(copyTest);
    };

    const handleCheckAll = (e) => {
        let copyTest = [...dataExams];
        let valor = e.target.checked;

        if (_url_helen === "https://centroquimico.helen-sw.com") {
            if (copyTest) {

                copyTest.map(x => {
                    if (!x.show_print) {
                        return;
                    }
                    if ((x.id_estatus >= 7 && x.id_estatus <= 10) || x.id_estatus == 12
                        || x.id_estatus == 13 || x.id_estatus == 15 || x.id_estatus == 18 || x.id_estatus == 5 || x.id_estatus == 21 || (x.id_estatus >= 2 && x.id_estatus <= 4)) {
                        x.check_box = valor;
                        x.listExam.map(i => {
                            if ((i.id_estatus >= 7 && i.id_estatus <= 10) || i.id_estatus == 12
                                || i.id_estatus == 13 || i.id_estatus == 15 || i.id_estatus == 18 || i.id_estatus == 5 || i.id_estatus == 21 || (i.id_estatus >= 2 && i.id_estatus <= 4)) {
                                i.check_box = valor;
                            }
                            return i;
                        });
                    }
                    return x;
                });
            }
        } else {
            if (copyTest) {
                copyTest.map(x => {
                    if (!x.show_print) {
                        return;
                    }
                    if ((x.id_estatus >= 6 && x.id_estatus <= 10) || x.id_estatus == 12
                        || x.id_estatus == 13 || x.id_estatus == 15 || x.id_estatus == 18 || x.id_estatus == 5 || x.id_estatus == 21 || (x.id_estatus >= 2 && x.id_estatus <= 4)) {
                        x.check_box = valor;
                        x.listExam.map(i => {
                            if (!i.show_print) {
                                return;
                            }
                            if ((i.id_estatus >= 6 && i.id_estatus <= 10) || i.id_estatus == 12
                                || i.id_estatus == 13 || i.id_estatus == 15 || i.id_estatus == 18 || i.id_estatus == 5 || i.id_estatus == 21 || (i.id_estatus >= 2 && i.id_estatus <= 4)) {
                                i.check_box = valor;
                            }
                            return i;
                        });
                    }
                    return x;
                });
            }
        }
        setdataExams(copyTest);
    };
    const handleCheckAllProfile = (e, id_profile, id_work_order_profile) => {
        let copyTest = [...dataExams];
        let valor = e.target.checked;
        let elementToUpdate = copyTest.find(x => x.id_work_order_profile === id_work_order_profile
            && x.id_profile == id_profile);
        if (_url_helen === "https://centroquimico.helen-sw.com") {
            if (elementToUpdate) {
                elementToUpdate.check_box = valor;
                elementToUpdate.listExam.map(i => {
                    if (!i.show_print) {
                        return false;
                    }
                    if ((i.id_estatus >= 7 && i.id_estatus <= 10) || i.id_estatus == 12
                        || i.id_estatus == 13 || i.id_estatus == 15 || i.id_estatus == 18 || i.id_estatus == 5 || i.id_estatus == 21 || (i.id_estatus >= 2 && i.id_estatus <= 4)) {

                        i.check_box = valor;
                    }
                    return i;
                });
            }
        } else {
            if (elementToUpdate) {
                elementToUpdate.check_box = valor;
                elementToUpdate.listExam.map(i => {
                    if (!i.show_print) {
                        return false;
                    }
                    if ((i.id_estatus >= 6 && i.id_estatus <= 10) || i.id_estatus == 12
                        || i.id_estatus == 13 || i.id_estatus == 15 || i.id_estatus == 18 || i.id_estatus == 5 || i.id_estatus == 21 || (i.id_estatus >= 2 && i.id_estatus <= 4)) {

                        i.check_box = valor;
                    }
                    return i;
                });
            }
        }

        setdataExams(copyTest);
    };

    const Impresionbyexam = async (workOrderId) => {

        let order = nimData.find(w => w.id_work_order === parseInt(workOrderId));

        if (!order) {
            createSweet("error", "error", "Error", "No se encontró la orden");
            return;
        }

        let id = order.nim2
        let _valid = false


        dataExams.forEach(_valid1 => {
            if (_valid1.check_box === true) {
                _valid = _valid1.check_box
            }
            _valid1.listExam.forEach(_f => {
                if (_f.check_box === true) {
                    _valid = _f.check_box
                }
            });
        });


        let payload = {
            "nim": id,
            "password": "",
            "type": "NP",
            "lista_exames": dataExams,
            "letter": letter,
        }

        if (_valid !== false) {


            let data = JSON.stringify(payload);
            let token = localStorage.getItem("token");

            await fetch(ConfigServer.serverUrl + "/api/PrintResult/DownloadSheetResultsByExam?is_printed=true", {
                method: 'POST',
                body: data,
                headers: new Headers({
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/json"
                })
            })
                .then(response => {
                    if (response.status !== 200) {
                        createSweet("warning", "warning", "No se ha podido descargar el pdf");
                        return;
                    }
                    return response.blob();
                })
                .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "hoja_resultados_" + nim + ".pdf");
                    document.body.appendChild(link);
                    link.click();
                    createSweet("success", "success", "Descarga completa");
                });
        }
        else {
            createSweet("warning", "warning", "Debe de seleccionar al menos un estudio para poder imprimir");

        }
    }

    const togglePrintI = () => {
        setModalPrintI(!modalPrintI);
    }
    //#endregion PRINT PDF RESULT
    //

    function exportToExcel(data) {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const fileName = 'data.xlsx';

        if (typeof window !== 'undefined' && window.navigator && window.navigator.msSaveOrOpenBlob) {
            // Para Internet Explorer
            window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
        } else {
            // Para otros navegadores
            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(url);
        }
    }

    //#region Send Exams 
    const [typeModalExamEmail, setTypeModalExamEmail] = useState("viewExamEmail");
    const [nimSend, setNimSend] = useState(0);
    const [modalExamsEmail, setModalExamsEmail] = useState(false);
    const [modalCheckEmail, setModalCheckEmail] = useState(false);

    const toggleListExamEmail = () => {
        setModalExamsEmail(!modalExamsEmail);
    }

    const toggleExamEmail = () => {
        setModalCheckEmail(!modalCheckEmail)
    }

    const handleFindExam = () => {

        let checkExam = dataExams.find(w => w.check_box === true)

        let individual = [];
        let profile = [];
        let profiles = [];

        dataExams.forEach((data, index) => {
            individual.push({
                "check_box": data.check_box,
            })
            profile.push({
                "listExam": data.listExam
            });
        });

        profile.forEach((data, index) => {

            data.listExam.forEach((check) => {
                profiles.push({
                    "check_box": check.check_box,
                })
            })
        })

        let checkIndividual = false;
        let checkProfiles = false;
        let _checkIndividualTemp = individual.find(w => w.check_box)
        if (_checkIndividualTemp !== undefined) {
            checkIndividual = _checkIndividualTemp.check_box
        }

        let _checkProfilesTemp = profiles.find(w => w.check_box);
        if (_checkProfilesTemp !== undefined) {
            checkProfiles = _checkProfilesTemp.check_box;
        }

        if (checkIndividual === true || checkProfiles === true) {
            setModalExamsEmail(!modalExamsEmail);
            if (modalExamsEmail === true) {
                handleSendExam();
            }
        }
        else {
            createSweet("", "warning", "Advertencia", "No se ha seleccionado ningún examen");
        }
    }

    const handleSendExam = async (id_workOrder, nim2) => {
        console.log("🚀 ~ handleSendExam ~ nim2:", nim2)
        let order = nimData.find(w => w.id_work_order === parseInt(id_workorder_send));
        let id = order.nim2
        let patient = dataSend.find(x => x.nim === id)
        setSendTo(patient);
        setNimSend(nim2)
        toggleExamEmail();
    }

    const handleListExamEmail = async (id_work_order) => {

        let _listTmp = await handleRequest("GET", `WorkOrder/GetExambyWorkOrder/${id_work_order}`, 'invoice');

        if (_listTmp !== null) {
            let dataExamsTemp = [];
            _listTmp.forEach((item) => {
                if (item.listExam && item.listExam.length > 0) {
                    item.listExam.forEach((exam) => {
                        dataExamsTemp.push({
                            nim: item.nim,
                            id_work_order_exam: exam.id_work_order_exam,
                            id_work_order_profile: null,
                            id_estatus: exam.id_estatus,
                            id_profile: null,
                            id_exam: exam.id_exam,
                            name: exam.name,
                            listExam: [],
                            check_box: false,
                            show_print: exam.show_print,
                            has_been_send: exam.has_been_send,
                            sendBy: exam.sendBy,
                            total_sends: exam.total_sends,
                            sends_to_patient: exam.sends_to_patient,
                            sends_to_doctor: exam.sends_to_doctor,
                            last_send_date: exam.last_send_date,
                            patient_audit_details: exam.patient_audit_details ?? [],
                            doctor_audit_details: exam.doctor_audit_details ?? [],
                            print_audit_details: exam.print_audit_details ?? [],
                        });
                        
                    });

                }
                if (item.listProfile && item.listProfile.length > 0) {
                    item.listProfile.forEach((profile) => {
                        dataExamsTemp.push({
                            nim: item.nim,
                            id_work_order_exam: 0,
                            id_work_order_profile: profile.id_work_order_profile,
                            id_estatus: profile.id_status,
                            id_profile: profile.id_profile,
                            id_exam: null,
                            name: profile.name_profile,
                            listExam: profile.listExam,
                            sent_exams: profile.sent_exams ?? 0,
                            total_exams: profile.total_exams ?? profile.listExam.length,
                            status_profile: profile.status_profile ?? "",
                            check_box: false,
                            show_print: profile.show_print,
                            patient_audit_details: profile.patient_audit_details ?? [],
                            doctor_audit_details: profile.doctor_audit_details ?? [],
                            print_audit_details: profile.print_audit_details ?? [],
                        });
                    });
                }
            });

             const config = _listTmp[0];

            setSendConfig({
                send_email: config.send_email ?? false,
                send_doctor: config.send_doctor ?? false,
                send_whatsapp: config.send_whatsapp ?? false,
                send_whatsapp_doctor: config.send_whatsapp_doctor ?? false,
                print_results: config.show_print ?? false,
            });


            setid_workorder_send(id_work_order);
            setdataExams(dataExamsTemp);
            setTypeModalExamEmail("viewExamEmail");
            toggleListExamEmail();
        }
    }
    const sendResultEmail = async (sendDoctor) => {
        let order = nimData.find(w => w.id_work_order === parseInt(id_workorder_send));

        let id = order.nim2;

        let payload = {
            nim: id,
            password: "",
            type: "NP",
            doctor: sendDoctor,
            lista_exames: dataExams
        };

        let requestOptions = {
            method: 'POST',
            body: JSON.stringify(payload)
        };

        const respuesta = await sendRequest(requestOptions, "PrintResult/SendResultForEmailByExam");

        if (respuesta.code === 200) {
            return true;
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, sendResultForEmail);
            return false;
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Resultados", respuesta.data.msg);
            return false;
        }
        else {
            createSweet("error", "warning", "Resultados", respuesta.data.msg);
            return false;
        }
    };

    //#endregion Send Exams

    const handleRequest = async (method, methodUrl, nameMethod, body = null) => {
        let requestOptions = {
            method: method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions, methodUrl);

        if (response.code === 200) {
            return response.data;
        }
        else if (response.code === 401) {
            validarSesion(history, response.code, handleRequest);
        }
        else if (response.code === 500) {
            createSweet("error", "error", nameMethod, "Ocurrio un error en el servidor");
        }
        // else {
        //     createSweet("warning", "warning", nameMethod, response.data.msg);
        // }
        return null;
    }


    const handleSendEmail = async ({ sendPatient, sendDoctor, printResult }) => {

        if (!sendPatient && !sendDoctor && !printResult) return;

        if (sending) return;

        try {

            setSending(true);

            let results = [];
            
            if (printResult) {

                const id = id_workorder_send;

                await Impresionbyexam(id);

            }

            if (sendPatient) {
                results.push(await sendResultEmail(false));
            }

            if (sendDoctor) {
                results.push(await sendResultEmail(true));
            }

            const allSent = results.every(r => r === true);

            if (allSent || printResult) {

                createSweet(
                    "create",
                    "success",
                    "Éxito!",
                    "Los resultados se han procesado correctamente"
                );

                toggleListExamEmail();
                getAmount();
            }

        } finally {
            setSending(false);
        }
    };

    

    const printTicketCedimi = async (_workOrderId) => {

        let token = localStorage.getItem("token");
        // await fetch(ConfigServer.serverUrl + "/api/CashFlow/PrintTicket/" + id_cash_flow, {
        await fetch(ConfigServer.serverUrl + `/api/PrintTicket/MakeWorkOrderTicketCedimi/${_workOrderId}`, {
            method: 'GET',
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
            .then(response => {
                if (response.status !== 200) {
                    createSweet("warning", "warning", "No se descargo el Ticket");
                    return;
                }

                return response.blob();
            })
            .then(blob => {
                var url = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Orden de trabajo ticket.pdf")
                document.body.appendChild(link);
                link.style.display = 'none';
                link.click();
            })

    }



    const handleSwitchChange = (e) => {
        const isChecked = e.target.checked;
        setJustMe(isChecked);
        getAmount(true, null, false, isChecked);
    };


    function exportToExcelTrazability(data) {
        const processedData = data.flatMap(row => {
            const results = [];
            const profileName = row.profile_name?.props?.children || 'Sin Nombre de Perfil';

            if (row.type === 'profile') {
                row.listExm.forEach(exam => {
                    const baseRow = {
                        Estudio: `${profileName} - Examen: ${exam.name?.props?.children || 'Sin Nombre'}`,
                        'Toma de muestra': exam.is_toma ? "✅" : "❌",
                        'Fecha Inicio': exam.traceabilitSampling?.[0]?.init_time || "Sin Fecha",
                        Usuario: exam.traceabilitSampling?.[0]?.flebo || "Sin Usuario",
                        Envío: exam.is_send1 ? "✅" : "❌",
                        'Fecha Envio': exam.traceabilitSend?.[exam.traceabilitSend.length - 1]?.init_time_procces2 || "---",
                        'Usuario de Envio': exam.traceabilitSend?.[exam.traceabilitSend.length - 1]?.user_process2 || "---",
                        Recepción: exam.is_send2 ? "✅" : "❌",
                        'Fecha Recepción': exam.traceabilitSend?.[exam.traceabilitSend.length - 1]?.init_time_procces3 || "---",
                        'Usuario Recepción': exam.traceabilitSend?.[exam.traceabilitSend.length - 1]?.user_process3 || "---"
                    };

                    results.push(baseRow);

                    if (exam.is_curve && Array.isArray(exam.arrayCurves)) {
                        exam.arrayCurves.forEach(curve => {
                            results.push({
                                Estudio: `→ Muestreo ${curve.num_samplings}`,
                                'Toma de muestra': curve.user_flebo !== null ? "✅" : "❌",
                                'Fecha Inicio': curve.init_time_flebo || "---",
                                'Usuario': curve.user_flebo || "---",
                                Envío: "✔",
                                'Fecha Envio': curve.init_time_procces2 || "---",
                                'Usuario de Envio': curve.user_process2 || "---",
                                Recepción: "✔",
                                'Fecha Recepción': curve.init_time_procces3 || "---",
                                'Usuario Recepción': curve.user_process3 || "---"
                            });
                        });
                    }
                });
            } else {
                const baseRow = {
                    Estudio: row.name?.props?.children || 'Sin Nombre',
                    'Toma de muestra': row.is_curve ? "" : row.is_toma ? "✅" : row.check_forwarded ? "Remitida" : "❌",
                    'Fecha Inicio': row.is_curve ? "" : row.traceabilitSampling?.[0]?.init_time || (row.check_forwarded ? "N/A" : "Sin Fecha"),
                    Usuario: row.is_curve ? "" : row.traceabilitSampling?.[0]?.flebo || "",
                    Envío: row.is_curve ? "" : row.is_send1 ? "✅" : "❌",
                    'Fecha Envio': row.is_curve ? "" : row.traceabilitSend?.[row.traceabilitSend.length - 1]?.init_time_procces2 || "---",
                    'Usuario de Envio': row.is_curve ? "" : row.traceabilitSend?.[row.traceabilitSend.length - 1]?.user_process2 || "---",
                    Recepción: row.is_curve ? "" : row.is_send2 ? "✅" : "❌",
                    'Fecha Recepción': row.is_curve ? "" : row.traceabilitSend?.[row.traceabilitSend.length - 1]?.init_time_procces3 || "---",
                    'Usuario Recepción': row.is_curve ? "" : row.traceabilitSend?.[row.traceabilitSend.length - 1]?.user_process3 || "---"
                };

                results.push(baseRow);

                if (row.is_curve && Array.isArray(row.arrayCurves)) {
                    row.arrayCurves.forEach(curve => {
                        results.push({
                            Estudio: `- Toma N° ${curve.num_samplings}`,
                            'Toma de muestra': curve.user_flebo !== null ? "✅" : "❌",
                            'Fecha Inicio': curve.init_time_flebo || "---",
                            'Usuario': curve.user_flebo || "---",
                            Envío: curve.user_process2 !== null ? "✅" : "❌",
                            'Fecha Envio': curve.init_time_procces2 || "---",
                            'Usuario de Envio': curve.user_process2 || "---",
                            Recepción: curve.user_process3 !== null ? "✅" : "❌",
                            'Fecha Recepción': curve.init_time_procces3 || "---",
                            'Usuario Recepción': curve.user_process3 || "---"
                        });
                    });
                }
            }

            console.log("🚀 ~ exportToExcelTrazability ~ results:", results)
            return results;
        });

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(processedData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Trazabilidad');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        const fileName = 'Trazabilidad.xlsx';

        if (typeof window !== 'undefined' && window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
        } else {
            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(url);
        }

    }

    const [isLoading, setIsLoading] = useState(false);




    const exportToExcel2 = async (data) => {
        setIsLoading(true)

        try {

            const exportData = data.map((row, index) => {
                console.log("🚀 ~ exportToExcel2 ~ row:", row)
                console.log("🚀 ~ filterData ~ row:", row.name_patient?.props?.children?.[1]?.props?.children)

                const nimText = row.nim && row.nim.props ? row.nim.props.children?.[0]?.props?.children ?? "-----" : "-----";
                const fechaText = row.fechAndDate && row.fechAndDate.props ? row.fechAndDate.props.children?.[0]?.props?.children ?? "-----" : "-----";
                const horaText = row.fechAndDate && row.fechAndDate.props ? row.fechAndDate.props.children?.[1]?.props?.children ?? "-----" : "-----";
                const clienteText = row.name_patient?.props?.children?.[1]?.props?.children ?? "-----";

                return {
                    "#": index + 1,
                    NIM: nimText,
                    "Fecha": `${fechaText} `,
                    Cliente: clienteText
                };
            });

            // Creamos el archivo Excel
            const worksheet = XLSX.utils.json_to_sheet(exportData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const fileName = 'data.xlsx';

            // Guardar el archivo en el navegador
            if (typeof window !== 'undefined' && window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
            } else {
                const url = window.URL.createObjectURL(dataBlob);
                const link = document.createElement('a');
                link.href = url;
                link.download = fileName;
                link.click();
                window.URL.revokeObjectURL(url);
            }

        } catch (error) {
            console.error("Error exporting data:", error);
        } finally {
            setIsLoading(false);
        }
    };


    // ? CONFIGURATIO DATATABLE
    const renderStatusTag = (items) => {
        const baseStyle = { width: "82px", fontSize: "10px", textAlign: "center" };

        switch (items.id_estatus_order) {
            case 1:
                return <Tag style={baseStyle} severity="info" value="Abierta" />;
            case 2:
                return <Tag style={baseStyle} severity="warning" value="En Progreso" />;
            case 4:
                return <Tag style={baseStyle} severity="warning" value="Validada" />;
            case 5:
                return <Tag style={baseStyle} severity="warning" value="Parcial" />;
            case 6:
                return <Tag style={baseStyle} severity="warning" value="Liberado" />;
            case 7:
                return <Tag style={baseStyle} severity="success" value="Enviado" />;
            case 8:
                return <Tag style={baseStyle} severity="success" value="Entregado" />;
            case 9:
                return <Tag style={baseStyle} severity="success" value="Ent/Env" />;
            case 10:
                return <Tag style={{ ...baseStyle, backgroundColor: "#ff8000", color: "#fff" }} value="Autorizado" />;
            case 13:
                return <Tag style={baseStyle} severity="warning" value="Impresa" />;
            case 20:
                return <Tag style={baseStyle} severity="danger" value="Cancelada" />;
            default:
                return <Tag style={baseStyle} severity="secondary" value="Sin estatus" />;
        }
    };

    const [expandedRows, setExpandedRows] = useState(null);

    const rowExpansionTemplate = (data) => {
        const columnsPerRow = 5;

        const rows = [];
        for (let i = 0; i < data.length; i += columnsPerRow) {
            rows.push(data.slice(i, i + columnsPerRow));
        }
    }


    const [globalFilter, setGlobalFilter] = useState("");

    const filterData = (data, filter) => {
        return data.filter(row => {
            console.log("🚀 ~ filterData ~ row:", row.name_patient?.props?.children?.[1]?.props?.children)
            const nimText = row.nim && row.nim.props ? row.nim.props.children?.[0]?.props?.children ?? "-----" : "-----";
            const fechaText = row.fechAndDate && row.fechAndDate.props ? row.fechAndDate.props.children?.[0]?.props?.children ?? "-----" : "-----";
            const statusText = renderStatusTag(row)?.props?.value ?? "-----";

            const clienteText = _url_helen === pyrsa ?
                row.name_patient?.props?.children?.[1]?.props?.children ?? "-----" :
                row.name_patient?.props?.children ?? "-----";


            const name_company = row.nim?.props?.children?.reduce((acc, child) => {
                if (child?.props?.children) {
                    acc.push(child.props.children);
                }
                return acc;
            }, []).join(" ") ?? "-----";

            return (
                nimText.toLowerCase().includes(filter.toLowerCase()) ||
                fechaText.toLowerCase().includes(filter.toLowerCase()) ||
                clienteText.toLowerCase().includes(filter.toLowerCase()) ||
                name_company.toLowerCase().includes(filter.toLowerCase()) ||
                statusText.toLowerCase().includes(filter.toLowerCase())
            );
        });
    };

    const [expandedRows2, setExpandedRows2] = useState(null);

    const rowExpansionTemplate2 = (data) => {
        const columnsPerRow = 5;

        const rows = [];
        for (let i = 0; i < data.length; i += columnsPerRow) {
            rows.push(data.slice(i, i + columnsPerRow));
        }
    }

    const modalFullRef = useRef(null);
    const [globalFilter2, setGlobalFilter2] = useState("");



    const filterData2 = (data, filter) => {
        const search = filter.toLowerCase();

        return data.filter(row => {
            console.log("🚀 ~ filterData2 ~ row:", row)

            const nimText =
                String(row.nim?.props?.children?.[0]?.props?.children ?? "")
                    .toLowerCase();

            const nimPatient =
                _url_helen === pyrsa
                    ? String(
                        row.name_patient?.props?.children?.props?.children?.[0]?.props?.children ?? ""
                    ).toLowerCase()
                    : String(
                        row.name_patient?.props?.children?.props?.children?.[0] ?? ""
                    ).toLowerCase();



            const fechaText =
                String(row.fechAndDate?.props?.children?.[0]?.props?.children ?? "")
                    .toLowerCase();

            const clienteText =
                _url_helen === pyrsa
                    ? String(row.name_patient?.props?.children?.props?.children?.[1]?.props?.children ?? "").toLowerCase()
                    : "";

            const name_company =
                String(
                    row.nim?.props?.children
                        ?.reduce((acc, child) => {
                            if (child?.props?.children) acc.push(child.props.children);
                            return acc;
                        }, [])
                        .join(" ")
                ).toLowerCase();

            const statusText =
                String(renderStatusTag(row)?.props?.value ?? "").toLowerCase();

            const searchAgreement =
                _url_helen === pyrsa
                    ? String(row.name_patient?.props?.children?.props?.children?.[2]?.props?.children ?? "").toLowerCase()
                    : "";

            return (
                nimText.includes(search) ||
                fechaText.includes(search) ||
                name_company.includes(search) ||
                nimPatient.includes(search) ||
                statusText.includes(search) ||

                (_url_helen === pyrsa && clienteText.includes(search)) ||
                (_url_helen === pyrsa && searchAgreement.includes(search))
            );
        });
    };

    const filterOptions = (option, input) => {
        if (input) {
            return option.label.props.children[1].props.children.toLowerCase().includes(input.toLowerCase());
        }
        return true;
    };


    //#region

    const resetModalExamEmail = () => {
        setStep(1);
        setdataExams([]);
        setSendConfig({
            send_email: false,
            send_doctor: false,
            send_whatsapp: false,
            send_whatsapp_doctor: false

        });
        setAuditPanel(null);
    };
    //#endregion


    //#region SEND RESULT

    const toggleProfile = (id) => {
        setOpenProfiles(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const handleMarkAllClick = () => {
        setMarkAllActive(!markAllActive);
        handleCheckAll({
            target: { checked: !markAllActive }
        });
    };

    const selectedCount = dataExams.reduce((total, item) => {
        if (item.id_profile === null) {
            return total + (item.check_box ? 1 : 0);
        }

        if (item.listExam?.length > 0) {
            return total + item.listExam.filter(e => e.check_box).length;
        }

        return total;
    }, 0);

    const statusMap = {
        1: { label: "Abierto", class: "status-info" },
        2: { label: "En Progreso", class: "status-warning" },
        3: { label: "Capturado", class: "status-warning" },
        4: { label: "Validado", class: "status-warning" },
        5: { label: "Parcial", class: "status-warning" },
        6: { label: "Liberado", class: "status-warning" },

        7: { label: "Entregado", class: "status-success" },
        8: { label: "Entregado", class: "status-success" },
        9: { label: "Entregado", class: "status-success" },
        10: { label: "Entregado", class: "status-success" },
        11: { label: "Modificada", class: "status-warning" },
        12: { label: "Entregado", class: "status-success" },
        13: { label: "Entregado", class: "status-success" },
        14: { label: "Pendiente", class: "status-warning" },
        15: { label: "Entregado", class: "status-success" },
        17: { label: "Desvalidado", class: "status-primary" },
        18: { label: "Entregado", class: "status-success" },

        20: { label: "Cancelado", class: "status-danger" },
        21: { label: "Entregado", class: "status-success" }
    };

    const getStatus = (status) => {
        let config = statusMap[status] || { label: "-", class: "" };

        if (status === 13 && _url_helen === labcen) {
            return {
                ...config,
                label: "Impreso",
                class: "status-warning"
            };
        }

        return config;
    };
    
    
    const isSelectable = (estatus, show_print) => {
        if (!show_print) return false;

        return (
            (estatus >= 6 && estatus <= 10) ||
            estatus === 12 ||
            estatus === 13 ||
            estatus === 15 ||
            estatus === 18 ||
            estatus === 5 ||
            estatus === 21 ||
            (estatus >= 2 && estatus <= 4)
        );
    };
    
    
    const toggleAuditPanel = (type, examId, data, nameExam) => {
            // console.log("😺 auditPanel", auditPanel);
        if (
            
            auditPanel &&
            auditPanel.type === type &&
            auditPanel.examId === examId &&
            auditPanel.nameExam === nameExam
        ) {


            setAuditPanel(null);
            return;
        }

        setAuditPanel({
            type,
            examId,
            data,
            nameExam
        });
    };

    const getFullAuditHistory = (exam) => {

        const all = [
            ...(exam.patient_audit_details || []),
            ...(exam.doctor_audit_details || []),
            ...(exam.print_audit_details || [])
        ];

        return all.sort((a, b) => new Date(b.send_date) - new Date(a.send_date));
    };



    useEffect(() => {

        const main = document.querySelector('.results-digital-modal.p-dialog');

        if (!main) return;

        const observer = new ResizeObserver(entries => {
            const audit = document.querySelector('.audit-dialog.p-dialog');
            if (audit) {
                audit.style.height = entries[0].target.offsetHeight + "px";
            }
        });

        observer.observe(main);

        return () => observer.disconnect();

    }, [modalExamsEmail, auditPanel]);


        useEffect(() => {
        if (!modalExamsEmail) {
            resetModalExamEmail();
        }
    }, [modalExamsEmail]);


    
    

    //#endregion

    return {
        //*DELIVERY
        toggleCheckDelivery, handleCheckDelivery, modalCheckDelivery, idWorkOrder,

        //*PAGINATION
        totalPageCount, currentPage, nextPage, previousPage, goToPage, getdashboard, nim, handleInputChange, loading,

        //*INDICATORS
        nimData, patientCompany, patientTotal, countTotal, examsAndProfile, orderTotal, orderCancell, totalInvoices,

        //*methods absolutes
        printTicket, printSticker, navigateConfigEtiqueta, navigateUpdate, handleViewTest, handleCloseViewTest, enableViewTest,
        typeModall, modalOrdenMedical, toggleMedical, handleMedical, workMedicalOrderPDF, loadingPdf, workMedicalOrderPDFDownload, printWorkOrder, changeEstatus, commentPatient, nimData,

        //*CHECK SPECIMEN
        handleModalCheckSpecimen, toggleCheckSpecimen, modalCheckSpecimen, specimensUncheck, checkSpecimens, loadingSpecimen, chek,

        //*PRINT PDF INDIVIDUAL
        handleListPrint, typeModalPrintI, modalPrintI, togglePrintI, dataExams, handleCheckProfile, handleCheckAll, handleCheckAllProfile, Impresionbyexam, id_workorder_print, letter,

        //*CONFIGURATION INVOICES AND REPORT
        toggleInvoice, handleInvoice, typeModalInvoice, modalInvoice, InvoicePDF, sendResultForEmail, exportToExcel, nimDataExcel,

        //*TRAZABILIDAd
        typePending, modalPending, toggleHistoric, dataSample, loadingSample, dataSendProcess2, dataSendProcess3, dataTrackingRecepetion, handleTrazabilidad, close, modalProps,
        namePatient, idGender, dataSection, dataID, treeviewRef, itemsTree, changeTree, savePendingMuestra, enable_tracking_toma,

        //*FILTERS DASHBOARD
        mDateRange1, mDateRange2, mSelectStatus, handleSelectValues, handleCleanFilter, viewFormFilters, handleViewFilters, navigateInvoice,

        //*SERVICE EMAIL
        handleSendExam, toggleExamEmail, modalCheckEmail, sendResultEmail, modalExamsEmail, handleListExamEmail, toggleListExamEmail, typeModalExamEmail, id_workorder_send, sendTo, handleFindExam,

        //*CONFIGURATION EMAIL
        respuestaAPI, dataCompany, id_company, credit_payment, typeNumber, validinvoice,

        //*FILTER
        refusedGlobal, filterSections, handleFilterSections, maquila,

        //*CONFIGURATION SEND WHATSAPP
        handleSendWhatss, modalPreviewSend, toggleModalSend, validNumber, id_patient, sendResultsWhatsapp,

        //*TYPE SERVICE
        handleChangeFilterService, listTypeService, id_type_service, _interfaced_hospital,
        PrimarycolorLineTab, setPrimarycolorLineTab, getAmount, handleView, loadingMicro, handleCleanFilterMicro,

        // ! CONFIGURATION MICROSANITARY
        _active_micro, _title_dashboard, _url_helen,

        printTicketCedimi,

        handleSwitchChange, justMe,
        dataTraceability, loadingTrazability, exportToExcelTrazability,
        exportToExcel2, isLoading, enable_whatsapp,
        _valid_Finance, _finance2,

        // ? CONFIGURATION DATATABLE
        renderStatusTag, globalFilter, setGlobalFilter, filterData, expandedRows2, setExpandedRows2, rowExpansionTemplate2,
        modalFullRef, globalFilter2, setGlobalFilter2, filterData2, expandedRows, setExpandedRows, rowExpansionTemplate,

        arrayStatus, filterOptions, branchName,
        showInvoiceAlert, toggleAlert, modalAlert,totalMicro, totalClinical, sendConfig,

        handleSendEmail, sending,

        resetModalExamEmail, 

        setStep, setAuditPanel, auditPanel, markAllActive, handleMarkAllClick, step,
        isSelectable, statusMap, toggleAuditPanel, toggleProfile, openProfiles, selectedCount,
        getFullAuditHistory, getStatus
        




    }
}